import { render, staticRenderFns } from "./EstimateDayworkRates.vue?vue&type=template&id=351987b8&"
import script from "./EstimateDayworkRates.vue?vue&type=script&lang=js&"
export * from "./EstimateDayworkRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports